import classNames from 'classnames'
import React from 'react'
import { IconSize } from '../icon'
import { LoadingIndicatorSize } from '../loading-indicator'
import type { ButtonSizeType, ButtonVariantsType } from './base-button'
import { BaseButton } from './base-button'
import styles from './IconButton.module.scss'
import type { IconButtonProps, IconButtonSizeType } from './types'
import { IconButtonSize, IconButtonVariants } from './types'

const mapperSizes: Map<IconButtonSizeType, IconSize> = new Map([
  [IconButtonSize.xxsmall, IconSize.small],
  [IconButtonSize.xsmall, IconSize.small],
  [IconButtonSize.small, IconSize.medium],
  [IconButtonSize.medium, IconSize.large],
  [IconButtonSize.large, IconSize.large],
])

const IconButton: React.FC<IconButtonProps> = ({
  size = IconButtonSize.medium,
  loading = false,
  variant = IconButtonVariants.primary,
  disabled = false,
  rtl = false,
  icon: Icon,
  className,
  ...props
}) => {
  const iconSize = mapperSizes.get(size) || IconSize.medium
  const loadingIndicatorSize =
    size === IconButtonSize.xsmall ? LoadingIndicatorSize.small : LoadingIndicatorSize.medium

  const overridenButtonProps = {
    ...props,
    size: size as ButtonSizeType,
    variant: variant as ButtonVariantsType,
  }

  return (
    <BaseButton
      className={classNames(styles['pintxo-icon-button'], className)}
      rtl={rtl}
      loading={loading}
      disabled={disabled}
      loadingIndicatorSize={loadingIndicatorSize}
      {...overridenButtonProps}
    >
      {!loading && Icon && <Icon size={iconSize} outline={true} rtl={rtl} />}
    </BaseButton>
  )
}

export default IconButton
